
<template>
  <div class="to-wx">
    <Head :info="headInfo"></Head>
    <div class="container">
        <div class="wx">
            <div class="user-wx">
                <div class="wx-label">提现至</div>
                <div class="wx-title"><img :src="targetImg" alt="">微信</div>
                <div class="wx-user">({{info.user}})</div>
            </div>
            <div class="user-wx">
                <div class="wx-label">姓名</div>
                <div class="wx-name">{{info.nickName}}</div>
            </div>
            <div class="user-wx" v-if="chargeTo.target=='zfb'">
                <div class="wx-label">账号</div>
                <div class="wx-name">{{info.username}}</div>
            </div>
            <div class="user-wx" v-if="chargeTo.target=='bank'">
                <div class="wx-label">银行卡号</div>
                <div class="wx-name">{{info.username}}</div>
            </div>
        </div>
        <div class="charge-box">
            <div class="charge-title">可提现金额：{{chargeTo.money}}</div>
            <div class="charge">
                  <van-field v-model="charge" @input="validateCharge()" label="￥：" placeholder="请输入提现金额" >
                      <template #button>
                        <div class="charge-btn" @click="getAll()">全部提现</div>
                    </template>
                  </van-field>
            </div>
            <div class="tips">最低1元，最高4999元</div>
        </div>
        <div class="btnbox">
            <van-button :disabled="disabled" round size="large" color="linear-gradient(to right, #F5251B, #FB6149)">
            提现
            </van-button>
        </div>
    </div>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'
import {ls} from '@/utils/localStorage'

// 组件
export default {
  name: 'toWx',
  components: {Head,Cell},
  data() {
    return {
        headInfo:{
            name: '提现至微信'
        },
        info:{
            user:'顺子哥',
            username:'李顺',
            money: 432.2
        },
        charge:'',
        disabled:true,
        targetImg: require('../../assets/images/wx.png'),
        chargeTo:{
            target: 'wx'
        }
    };
  },
  created() {
     this.initData()
     this.getUserInfo()
  },
  methods: {
      validateCharge() {
        this.disabled = this.charge?false:true
      },
      getAll() {
          this.charge = this.chargeTo.money
          this.validateCharge()
      },
      getUserInfo() {
          console.log(this.$route)
        let param = {
            // refereeId: ls.get('refereeId')
        }
        this.$services.getTkDataById({method:'post',data:param}).then(res=> {
        
        this.info = res.data[0]
        })
    },
      initData() {
        let param = {
            target: this.$route.query.target
        }
        this.chargeTo = this.$route.query
        console.log(this.chargeTo)
        let targetName = param.target=='wx'?'微信':(param.target=='bank'?'银行卡':'支付宝')
        this.targetImg = param.target=='wx'?require('../../assets/images/wx.png'):(param.target=='bank'?require('../../assets/images/yinhang.png'):require('../../assets/images/zfb.png'))
        this.headInfo.name = '提现至'+targetName
      }
  }
};
</script>

<style lang="less" scoped>
.to-wx{
    background-color: @colorBg;
    .wx{
        background-color: #fff;
        .wx-label{
            width: 60px;
            font-size: 14px;
            color: #808080;
            display: flex;
            justify-content: flex-end;
            margin-right: 26px;
        }
        &>div{
            padding: 18px;
        }
        .user-wx{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid @colorBg;
            .wx-title{
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 21px;
                    height: 21px;
                    margin-right: 7px;
                }
            }
            .wx-user{
                flex: 1;
                display: flex;
                justify-content: flex-start;
                margin-left: 10px;
                color: #A4A4A4;
            }
            .wx-name{
                flex: 1;
                display: flex;
                justify-content: flex-start;
            }
        }
    }
    .charge-box{
        margin-top: 10px;
        background-color: #fff;
        .charge-title{
            padding: 20px 25px;
            font-size: 15px;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
        }
        .charge{
            border-bottom: 1px solid @colorBg;
            /deep/.van-cell{
                padding: 14px 25px;
                .van-field__label{
                    font-size: 24px;
                    font-weight: bold;
                    width: auto;
                }
            }
            .charge-btn{
                font-size: 15px;
                color: #FD2610 ;
            }
            
        }
        .tips{
            padding: 14px 29px;
            font-size: 13px;
            color: #c1c1c1;
            text-align: left;
        }
    }
    .btnbox{
        padding: 20px 15px;
        /deep/.van-button__text{
            letter-spacing: 10px;
        }
    }
}
</style>
